var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3622_116365",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3622_116365)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6421 9.83645H9.62088C8.57729 9.83645 7.67922 10.1794 6.92665 10.8653C6.17408 11.5512 5.7978 12.4006 5.7978 13.4134C5.7978 14.4262 6.17408 15.2772 6.92665 15.9663C7.67922 16.6554 8.57729 16.9999 9.62088 16.9999H16.0478C16.2606 16.9999 16.4388 17.0717 16.5824 17.2153C16.726 17.3589 16.7978 17.5371 16.7978 17.7499C16.7978 17.9627 16.726 18.1409 16.5824 18.2845C16.4388 18.4281 16.2606 18.4999 16.0478 18.4999H9.62088C8.15808 18.4999 6.9052 18.0102 5.86225 17.0307C4.81932 16.0512 4.29785 14.8454 4.29785 13.4134C4.29785 11.9813 4.81932 10.7772 5.86225 9.8009C6.9052 8.82463 8.15808 8.3365 9.62088 8.3365H16.6421L14.3863 6.0807C14.2478 5.94223 14.177 5.7682 14.1738 5.5586C14.1706 5.34898 14.2414 5.17174 14.3863 5.02687C14.5312 4.882 14.7068 4.80957 14.9132 4.80957C15.1196 4.80957 15.2952 4.882 15.4401 5.02687L18.867 8.45377C18.9606 8.54737 19.0266 8.64609 19.0651 8.74992C19.1036 8.85377 19.1228 8.96595 19.1228 9.08647C19.1228 9.20699 19.1036 9.31916 19.0651 9.423C19.0266 9.52684 18.9606 9.62556 18.867 9.71915L15.4401 13.1461C15.3017 13.2845 15.1276 13.3554 14.918 13.3586C14.7084 13.3618 14.5312 13.2909 14.3863 13.1461C14.2414 13.0012 14.169 12.8256 14.169 12.6191C14.169 12.4127 14.2414 12.2371 14.3863 12.0922L16.6421 9.83645Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedo);
export default __webpack_public_path__ + "static/media/redo.e3617e89f8ee5d36adcf9f28fc09089e.svg";
export { ForwardRef as ReactComponent };